// extracted by mini-css-extract-plugin
export default {"wrapper":"stacked-bar_wrapper--Teycp","segment":"stacked-bar_segment--Q4rF4","filled":"stacked-bar_filled--DFRu3"};